module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/dig-in-day-logo-black-c6d8c3f9a6e700b5203c059d56ae3603.png";